import { EXPERIMENT_KEY, PAGE_VERSION } from './constants'

// The GrowthBook assignments reach fast pages through /load-services.js, which defines
// initialDataLayerSettings (GoogleTagManagerDecorator#initial_tracking_settings) with `ab_v` as a
// JSON string. It is read at push time because the script lands after the page has mounted.
const readExperimentVariant = () => {
  try {
    const abValues = JSON.parse(window.initialDataLayerSettings?.ab_v || '{}')
    return abValues[EXPERIMENT_KEY]
  } catch (error) {
    return undefined
  }
}

export const getPageAttributes = () => {
  const variant = typeof window === 'undefined' ? undefined : readExperimentVariant()
  const isInExperiment = variant !== undefined && variant !== null

  return {
    page_version: PAGE_VERSION,
    experiment_key: isInExperiment ? EXPERIMENT_KEY : '',
    experiment_variant: isInExperiment ? String(variant) : '',
  }
}

// Read by the shared UserTracker helpers, so the navigation search box and the model card events
// on this page carry the same attributes as the page's own events.
export const registerPageAttributes = () => {
  window.getAnalyticsPageAttributes = getPageAttributes
}
